import React from 'react'
// hooks
import { useNetworkStatus } from 'hooks/useNetworkStatus'
import { useCustomColumnFields } from 'hooks/risks/useCustomColumnFields'
// context
import { RiskRegisterContext } from 'containers/Risks/RisksRegister/layers'
import { RiskTemplateAPIContext } from 'containers/Risks/RiskTemplate/Edit/layers/API'
// constants
import { SCHEDULED_HEADERS } from './constants'
// components
import Fields from './components/Fields'
import SortButton from './components/SortButton'
import RelatedFields from './components/RelatedFields'
import TableHeadLabel from 'components/PageComponents/RiskTemplates/Edit/components/RiskTemplateFields/components/Table/components/TableHead/TableHeadLabel'
// views
import { HeaderItemWrapper, RisksHeaderWrapper, Spacer } from './views'
// types
import { FieldType } from 'types/graphql'
// utils
import { getVisibleFields } from 'components/PageComponents/Risks/Register/components/RiskView/components/RisksContainer/components/utils'

interface Props {
  isScheduled: boolean
}

const ID_FIELD = { id: 'customerUniqueIdPostfix', fieldType: FieldType.Text }
const CREATED_AT_FIELD = { id: 'createdAt', fieldType: FieldType.Date }
const UPDATED_AT_FIELD = { id: 'updatedAt', fieldType: FieldType.Date }

const RisksHeader: React.FC<Props> = ({ isScheduled }) => {
  const onLine = useNetworkStatus()

  const { riskView } = React.useContext(RiskRegisterContext)
  const { riskTemplate } = React.useContext(RiskTemplateAPIContext)

  const { columnFields } = useCustomColumnFields()

  const { showParent, showCreatedAt, showUpdatedAt, showCreatedBy, showUpdatedBy } = getVisibleFields(
    riskView?.settings.fields
  )

  return (
    <RisksHeaderWrapper>
      {onLine && riskTemplate.generateCustomerUniqueId && (
        <HeaderItemWrapper>
          <TableHeadLabel label='Uniq ID' />
          <SortButton field={ID_FIELD} />
        </HeaderItemWrapper>
      )}
      {isScheduled && SCHEDULED_HEADERS.map((item) => <TableHeadLabel key={item} label={item} />)}
      {showParent && <TableHeadLabel label='Parent' />}
      {showCreatedAt && (
        <HeaderItemWrapper>
          <TableHeadLabel label='Created At' />
          <SortButton field={CREATED_AT_FIELD} />
        </HeaderItemWrapper>
      )}
      {showCreatedBy && <TableHeadLabel label='Created By' />}
      {showUpdatedAt && (
        <HeaderItemWrapper>
          <TableHeadLabel label='Updated At' />
          <SortButton field={UPDATED_AT_FIELD} />
        </HeaderItemWrapper>
      )}
      {showUpdatedBy && <TableHeadLabel label='Updated By' />}
      {riskView?.customColumns?.map((column) => {
        const field = columnFields.find((item) => item.id === column.id)

        return (
          <HeaderItemWrapper key={column.id} data-testid='risk-header-column' data-entity-id={column.id}>
            <TableHeadLabel label={column.name} />
            {field && <SortButton field={field} />}
          </HeaderItemWrapper>
        )
      })}
      <Fields fields={riskTemplate.fields} />
      <RelatedFields />
      <Spacer />
    </RisksHeaderWrapper>
  )
}

export default RisksHeader
